<template>
  <standard
    v-if="type === `standard`"
    :label="label"
    :checked="checked"
    :disabled="disabled"
    :hover="hover"
    :focus="focus"
    :required="required"
    @onClick="onClick($event)"
  />
  <group
    v-else
    :label="label"
    :error-message="errorMessage"
    :help-message="helpMessage"
    :radio-array="radioArray"
    :required="required"
    @onClick="onClick($event)"
  />
</template>

<script>
// Default & Group Radio
import Standard from "./Standard";
import Group from "./Group";

export default {
  name: "Radio",
  components: {
    Standard,
    Group,
  },
  props: {
    /**
     * @description
     * Provides Label for Radio.
     * Availeble types are Standard (standard) and Group (group)
     */
    type: {
      type: String,
      validator: (val) => ["standard", "group"].includes(val),
      default: "standard",
    },
    /**
     * @description
     * Provides Label for Radio.
     */
    label: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Provides Error Message for Radio.
     * Applicable to Radio Group.
     */
    errorMessage: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Provides Help Message for Radio.
     * Applicable to Radio Group.
     */
    helpMessage: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Default Radio Input Checked value, Emits the value change on input & Parent Component needs to sync values emitted.
     * Applicable to Radio Group.
     * Expected Structure
     * [
     * {
     * id: "apples",
     * name: "apples",
     * label: "Apples",
     * checked: true,
     * },
     * ...
     * ]
     */
    radioArray: {
      type: Array,
      default() {
        return [];
      },
    },
    /**
     * @description
     * Default Radio Input Checked value, Emits the value change on input & Parent Component needs to sync values emitted.
     * Applicable to Standard Radio.
     */
    checked: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Radio should be Disabled.
     * Applicable to Standard Radio.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Radio should be Hoverable.
     * Applicable to Standard Radio.
     */
    hover: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Radio should be Focusable.
     * Applicable to Standard Radio.
     */
    focus: {
      type: Boolean,
      default: false,
    },
    required: { 
      type: Boolean,
      default: false
    },
  },
  methods: {
    onClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>